import { ReactElement, useState } from 'react'
import styled from 'styled-components'

import { ClickAwayListener } from 'components/v2/ClickAwayListener'
import { IDropdownContentProps, IDropdownOptions, IDropdownProps, IDropdownWrapperProps } from './types'

const setPosition = (props: IDropdownOptions): string => {
  if (props.right) {
    return `
      right: 0px;
    `
  } else if (props.left) {
    return `
      left: -7px;
    `
  }

  return `
    transform: translate(-50%, 0%);
    left: 50%;
  `
}

const StyledWrapper = styled.div<{ isForm?: boolean }>`
  position: relative;
  display: inline-block;
  width: ${({ isForm }): string => (isForm ? '100%' : 'auto')};
`

const StyledContainer = styled.div<IDropdownOptions & { isForm?: boolean }>`
  box-shadow: 8px 8px 16px rgba(102, 119, 150, 0.1);
  background-color: #ffffff;
  border-radius: 16px;
  padding: 0px;
  position: absolute;
  overflow: ${({ noOverflow }): string => (noOverflow ? 'visible' : 'auto')};
  top: calc(100% + 10px);
  min-width: ${(props): string => (props.isForm ? '100%' : '280px')};
  z-index: 1;
  margin-bottom: 20px;
  text-align: ${(props): string => (props.center ? 'center' : 'left')};
  ${setPosition}
`

const StyledContent = styled.div<{ noOverflow?: boolean }>`
  ${(props): string => {
    if (!props.noOverflow) {
      return `
        max-height: 200px;
        overflow: auto;
      `
    }

    return ''
  }}
`

const Dropdown = ({
  toggle,
  children,
  right,
  left,
  form,
  noIndicator,
  fitContent,
  noOverflow = false
}: IDropdownProps): ReactElement => {
  const [open, setOpen] = useState(false)

  const handleToggleClick = (): void => {
    setOpen(!open)
  }

  const handleClickAway = (): void => {
    setOpen(false)
  }

  return (
    <Wrapper onClickAway={handleClickAway} form={form}>
      <div onClick={handleToggleClick}>{toggle}</div>

      <Content
        open={open}
        right={right}
        left={left}
        form={form}
        noIndicator={noIndicator}
        fitContent={fitContent}
        noOverflow={noOverflow}
      >
        {children}
      </Content>
    </Wrapper>
  )
}

const Wrapper = ({ children, form, onClickAway }: IDropdownWrapperProps): ReactElement => {
  return (
    <ClickAwayListener onClickAway={onClickAway}>
      <StyledWrapper isForm={form}>{children}</StyledWrapper>
    </ClickAwayListener>
  )
}

const Content = ({
  children,
  open,
  right,
  left,
  form,
  noIndicator,
  className,
  fitContent,
  noOverflow,
  center
}: IDropdownContentProps): ReactElement | null => {
  if (!open) return null

  return (
    <StyledContainer
      className={className}
      right={right}
      left={left}
      isForm={form}
      noIndicator={noIndicator}
      fitContent={fitContent}
      center={center}
      noOverflow={noOverflow}
    >
      <StyledContent noOverflow={noOverflow}>{children}</StyledContent>
    </StyledContainer>
  )
}

export { Dropdown }
export default { Wrapper, Content }
